/**
 * https://github.com/wendux/fly/blob/master/README-CH.md
 */
// import wx from 'wx';
import Fly from 'flyio/dist/npm/fly';
// import Fly from 'flyio/dist/npm/wx';
import qs from 'qs';
import store from '../store';
import _ from './lodash';
// import storage from './storage';
import toast from './toast-vant';
// import router from '../router';
// import store from '../store';
const http = new Fly();
// 实例级配置
http.config.baseURL = '/bdsaas/ajax/';
http.config.timeout = 20000;
http.config.parseJson = false;
http.config.withCredentials = true;


function invalidToken() {
    console.log('invalidToken');
    if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
        // window.mobile.invalidToken();
    } else {
        window.webkit.messageHandlers.invalidToken.postMessage('');
    }
    // } else if (/(BD-IOS)/i.test(navigator.userAgent)) {
    //     window.webkit.messageHandlers.invalidToken.postMessage('');
    // } else {
    //     toast.fail({
    //         duration: 0,
    //         forbidClick: true,
    //         message: '用户会话无效'
    //     });
    // }
}

function success(response) {
    let result = {
        goOn: true,
        rspCode: 0,
        rspMsg: '',
        data: '',
        status: response.status,
        request: response.request
    };
    try {
        let data = _.isString(response.data) ? JSON.parse(response.data) : response.data;
        let rspCode = Number(data.rspCode);
        switch (rspCode) {
            case 0: // 正常返回
                result.goOn = true;
                result.rspCode = rspCode;
                result.rspMsg = data.rspMsg;
                result.data = data.data;
                break;
            case 80001: // 未登录
                invalidToken();
                result.goOn = false;
                result.rspCode = rspCode;
                result.rspMsg = data.rspMsg;
                break;
            default:
                result.goOn = true;
                result.rspCode = rspCode;
                result.rspMsg = data.rspMsg;
                result.data = data.data;
                break;
        }
    } catch (e) {
        console.log('bdhelper-success error', e);
        result.goOn = true;
        result.rspCode = -999;
        result.rspMsg = '数据发生错误';
    }
    return result;
}

function error(err) {
    console.log('bdhelper-error err', err);
    let result = {
        goOn: true,
        rspCode: -100,
        rspMsg: '',
        data: '',
        status: err.status,
        request: err.request
    };
    switch (Number(err.status)) {
        case 1:
            result.rspMsg = '请求超时';
            break;
        case 403:
            result.rspMsg = '无此权限';
            break;
        case 500:
            result.rspMsg = '请求发生错误';
            break;
        case 200:
            result.rspCode = err.rspCode;
            result.rspMsg = err.rspMsg;
            break;
        default:
            result.rspMsg = '网络异常';
            break;
    }
    if (err.request.toast) {
        toast.fail({
            duration: 1000,
            forbidClick: false,
            message: result.rspMsg
        });
    }
    return result;
}

//添加请求拦截器
http.interceptors.request.use((request) => {
    // console.log('request', request);
    if (request.headers['Content-Type'] != 'multipart/form-data') {
        // 给所有请求添加自定义header
        request.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
        let params = request.body;
        params['token'] = store.state.token || undefined;
        params['COMPANYID'] = store.state.companyId || undefined;
        request.body = qs.stringify(params);
    }
    //打印出请求体
    // console.log('request', request);
    // if (request.method == 'POST') {
    // } else if (request.method == 'GET') {
    //     request.body['token'] = token;
    // }
    //终止请求
    //var err=new Error("xxx")
    //err.request=request
    //return Promise.reject(new Error(""))

    //可以显式返回request, 也可以不返回，没有返回值时拦截器中默认返回request
    return request;
});

// http.interceptors.request.use((request) => {
//     wx.showNavigationBarLoading();
//     return request;
// });
http.interceptors.response.use(
    (response, promise) => {
        let result = success(response);
        console.log('http-success', result);
        switch (result.rspCode) {
            case 0:
                return promise.resolve(result);
            default:
                return promise.reject(result);
        }
    }, (err, promise) => {
        let result = error(err);
        console.log('http-error', result);
        return promise.reject(result);
    }
);
// http.upload

export default http;

// fly.post('/user', {
//     name: 'Doris',
//     age: 24
//     phone: "18513222525"
// })
// .then(function (response) {
//     console.log(response);
// })
// .catch(function (error) {
//     console.log(error);
// });
